module.exports = __webpack_public_path__ + "img/formule.07aa0c47.png";